import { ModalProgressBar } from "components/HelperComponents/ModalProgressBar";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const Dialog = ({
  show,
  onHide,
  total,
  action,
  modalTitle,
  modalMessage,
  okButtonTitle,
  okButtonClass,
  backdrop = true,
  children,
  showCancelButton = true
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [show]);

  function confirmDialog() {
    setIsLoading(true);
    typeof action === "function" ? action() : console.error("prop function olarak ayarlanmamış!");
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      //backdrop={isLoading ? "static" : backdrop}
      keyboard={!isLoading}
      disableEnforceFocus={true}
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={modalTitle} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {modalMessage ? (
            <FormattedMessage id={modalMessage} values={{ total: total }} />
          ) : (
            <FormattedMessage id="DIALOG.DELETEMESSAGE" values={{ total: total }} />
          )}
          {children}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          {showCancelButton && (
            <button
              id="dialog-cancel"
              type="button"
              onClick={onHide}
              className="btn btn-light btn-elevate mr-2"
              disabled={isLoading}
            >
              <FormattedMessage id="DIALOG.CANCEL" />
            </button>
          )}
          <button
            id="dialog-ok"
            type="button"
            onClick={confirmDialog}
            className={okButtonClass ? okButtonClass : "btn btn-light-primary btn-elevate"}
            disabled={isLoading}
          >
            <FormattedMessage id={okButtonTitle ? okButtonTitle : "DIALOG.OK"} />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Dialog;
